import React from 'react';

import DesktopLayout from 'layouts/DesktopLayout';
import { Navigate } from 'react-router-dom';

import { IRoute, IRouteMap } from './types';

export const getKiloStaffRouteMap = (isSalesTeam: boolean = false): IRouteMap => {
  const demoGymsRoute: IRoute = {
    key: 'demo-gyms',
    component: React.lazy(() => import('pages/private/admin/DemoGyms')),
    path: '/demo-gyms',
  };

  const gymsRoute: IRoute = {
    key: 'gyms',
    component: React.lazy(() => import('pages/private/admin/Gyms')),
    path: '/gyms',
  };

  const kiloStaffBaseRoutes = [
    {
      key: 'gym-athletes',
      component: React.lazy(() => import('pages/private/admin/Athletes')),
      path: '/gyms/:gymId/athletes',
    },
    {
      key: 'gym-staff',
      component: React.lazy(() => import('pages/private/admin/Staff')),
      path: '/gyms/:gymId/staff',
    },
  ];

  const redirectRoute = {
    key: 'redirect',
    component: () =>
      React.createElement(Navigate, { to: isSalesTeam ? '/demo-gyms' : '/gyms', replace: true }),
    path: '*',
  };

  const routes = isSalesTeam
    ? [...kiloStaffBaseRoutes, demoGymsRoute, redirectRoute]
    : [...kiloStaffBaseRoutes, gymsRoute, demoGymsRoute, redirectRoute];

  const demoGymNavLink = { key: 'demo-gyms', label: 'Demo Gyms', route: '/demo-gyms' };
  const navLinks = isSalesTeam
    ? [demoGymNavLink]
    : [{ key: 'gyms', label: 'Gyms', route: '/gyms' }, demoGymNavLink];

  return {
    layout: DesktopLayout,
    routes,
    navLinks,
  };
};
